// Google sign-in redirects back to the app root (the only redirect URL the
// Supabase Auth config allows), which would lose an OAuth consent request in
// progress. The consent page remembers itself here before the user signs in,
// and the app root sends the user back once the session exists.

const STORAGE_KEY = 'oauthConsentReturn';
const MAX_AGE_MS = 15 * 60 * 1000;

export function rememberOAuthConsent(url: string) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ url, at: Date.now() }));
  } catch {
    // storage unavailable: email/password sign-in still works in place
  }
}

export function forgetOAuthConsent() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}

// Returns the consent URL to go back to (and forgets it), if one is pending
export function takePendingOAuthConsent(): string | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    sessionStorage.removeItem(STORAGE_KEY);
    const { url, at } = JSON.parse(raw) as { url?: string; at?: number };
    if (typeof url !== 'string' || !url.startsWith('/oauth/consent?')) return null;
    if (typeof at !== 'number' || Date.now() - at > MAX_AGE_MS) return null;
    return url;
  } catch {
    return null;
  }
}
